import React, { useEffect, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../../auth/auth";
import GradingScoresChart from "./Grading Graph/Graph";
import AddNewGrade from "./Modal/AddNewGrade";
import { deleteGrading, getAverageGradings, getGradingsAssignments } from "../../../api/apiCall";
import { button, gradingsContainer } from "./style";
import { format } from "date-fns";
import { getFeedback } from "../../../utils/utils";
import { Modal as ModalAntd } from "antd";
import { toast } from "react-toastify";

const Gradings = () => {
  const {state} = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchParams, ] = useSearchParams();
  const [grades, setGrades] = useState([]);
  const [gradings, setGradings] = useState([]);
  const [, setOpen] = useState(false);

  const columns: any = [
    {
      field: "addedBy",
      headerName: "Added By",
      flex: 1
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      headerAlign: 'center',
      align: 'center',
      flex: 0.9, 
      renderCell: (params: any) => (
        <div>{format(params.row.createdDate, 'dd/MM/yyyy')}</div>
      )
    },
    {
      field: "attendance",
      headerName: "Attendance",
      headerAlign: 'center',
      align: 'center',
      flex: 1.1,
      renderCell: (params: any) => (
        <div>{getFeedback(params.row.attendance)}</div>
      )
    },
    {
      field: "attitude",
      headerName: "Attitude",
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      renderCell: (params: any) => (
        <div>{getFeedback(params.row.attitude)}</div>
      )
    },
    {
      field: "site_Feedback",
      headerName: "Site Feedback",
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      renderCell: (params: any) => (
        <div>{getFeedback(params.row.site_Feedback)}</div>
      )
    },
    {
      field: "delete",
      headerName: "Delete",
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      renderCell: (params: any) => (
        <Button
          style={{ backgroundColor: 'red', color: 'white' }}
          onClick={() => {
            setOpen(true);
            ModalAntd.confirm({
              title: `Are you sure you want to delete?`,
              onOk: () => handleDelete(params.id),
              okButtonProps: { danger: true },
              okText: 'YES',
              cancelText: 'NO',
              centered: true
            });
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const getGradings = async () => {
    const response = await getAverageGradings(state.user?.token, searchParams.get('workerId'))
    setGrades(response);
  }

  const getAllGradingsAssignments = async () => {
    const response = await getGradingsAssignments(state.user?.token, searchParams.get('workerId'));
    setGradings(response);
  }

  const handleDelete = async (id: any) => {
    const response = await deleteGrading(state.user?.token, id);
    if(response) {
      getAllGradingsAssignments();
      getGradings();
      toast.success('Grade deleted successfully')
    } else {
      toast.error('Something went wrong!')
    }
  }

  useEffect(() => {
    getGradings();
    getAllGradingsAssignments()
  }, [])

  return (
    <>
      <Box sx={gradingsContainer}>                
        <Box display="flex" justifyContent="space-between" mb={2}>
          <h2>Gradings Rate</h2>
          <Button
            onClick={() => setIsModalOpen(true)}
            variant="contained"
            color="primary"
            style={button}>
              Add New Gradings
          </Button>
        </Box>
        <Box display="flex" flexDirection="row" gap={2}>
          <Box flex={1}>
            <GradingScoresChart grades={grades} getGradings={getGradings} />
          </Box>
            <DataGrid
              rows={gradings}
              columns={columns}
              disableRowSelectionOnClick
              sx={{
                height: '570px',
                width: "100%",
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "#333",
                  fontWeight: "bold",
                  fontSize: 15.5,
                },
              }}
            />
        </Box>
      </Box>
      <Modal
        title={`Add New Post`}
        onClose={() => setIsModalOpen(false)}
        open={isModalOpen}
      >
        <AddNewGrade
          getGradings={getGradings}
          setIsModalOpen={setIsModalOpen}
          getAllGradingsAssignments={getAllGradingsAssignments}
        />
      </Modal>
    </>
  )
}

export default Gradings;
